import React from "react";

export default function CheckIcon(props) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <rect x="12" y="12" width="0" height="0" rx="0" ry="0" fill={props.color} />
      <g transform="translate(4.800000000000001 4.800000000000001) scale(0.6)" fill={props.color}>
        <path data-color="color-2" fill={props.color} d="M20.4,8.4c-0.5,0.1-0.8,0.7-0.7,1.2c0.2,0.8,0.3,1.6,0.3,2.4c0,5-4,9-9,9s-9-4-9-9s4-9,9-9 c1.7,0,3.3,0.5,4.7,1.3c0.5,0.3,1.1,0.1,1.4-0.3c0.3-0.5,0.1-1.1-0.3-1.4C15,1.6,13,1,11,1C4.9,1,0,5.9,0,12s4.9,11,11,11 s11-4.9,11-11c0-1-0.1-2-0.4-2.9C21.5,8.6,20.9,8.3,20.4,8.4z" />
        <path fill={props.color} d="M22.7,2.3c-0.4-0.4-1-0.4-1.4,0L11,12.6L7.7,9.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l4,4 c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l11-11C23.1,3.3,23.1,2.7,22.7,2.3z" />
      </g>
    </svg>
  );
}
